import { render, staticRenderFns } from "./page-dataProduct.vue?vue&type=template&id=4a7806d2&scoped=true&"
import script from "./page-dataProduct.vue?vue&type=script&lang=js&"
export * from "./page-dataProduct.vue?vue&type=script&lang=js&"
import style0 from "./page-dataProduct.vue?vue&type=style&index=0&id=4a7806d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7806d2",
  null
  
)

export default component.exports